<template>
	<div
		class="bg-yellow rounded-full px-1.5 py-px text-center text-xs leading-4.5 font-medium whitespace-nowrap text-black capitalize"
	>
		<slot />
	</div>
</template>
